export default "__VITE_ASSET__EfabC0xO__"